import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useStyle } from "@common/Modal/style";
import { ESimCardStatus } from "./interface/ISimCardRequest";
import { Loader } from "@common/Loader/Loader";
import { IFetchState } from "itsf-ui-common";

interface IParams {
    postReplacementSimState: IFetchState;
    errorCode?: ESimCardStatus;

    close(): void;

    confirm?(): void;
}

export const ReplacementSimErrorModal = (props: IParams) => {
    const {
        close,
        confirm,
        errorCode,
        postReplacementSimState: { error, isLoading },
    } = props;
    const { t } = useTranslation(["common", "glossary", "sim"]);
    const { classes } = useStyle({});

    let title = t("glossary:error");
    let content = t("common:genericError");
    let isSimActivated = false;

    if (errorCode) {
        if (errorCode === ESimCardStatus.ONGOING) {
            title = t("sim:pendingOrderTitle");
            content = t("sim:order.errors.ONGOING");
        } else if (errorCode === ESimCardStatus.IN_VALIDATION) {
            title = t("sim:inactiveSimTitle");
            content = t("sim:order.errors.IN_VALIDATION");
            isSimActivated = true;
        }
    } else if (error) {
        content = error.errorMessage || content;
    }

    return (
        <Dialog fullWidth maxWidth="md" open onClose={close}>
            <Grid className={classes.dialogClose} container justifyContent="flex-end">
                <Grid className={classes.dialogCloseIcon} item>
                    <IconButton aria-label="close" onClick={close}>
                        <CloseIcon color="disabled" />
                    </IconButton>
                </Grid>
            </Grid>
            {isLoading && <Loader size={40} />}
            {!isLoading && (
                <Fragment>
                    <DialogTitle>
                        <Grid container justifyContent="center">
                            <Grid item sm={12} xs={6}>
                                <Typography align="center" color="secondary" variant="h3">
                                    {title}
                                </Typography>
                            </Grid>
                        </Grid>
                    </DialogTitle>
                    <DialogContent>
                        <Typography align="center" variant="normal">
                            {content}
                        </Typography>
                    </DialogContent>
                </Fragment>
            )}
            <DialogActions>
                <Grid container justifyContent="center" spacing={2}>
                    <Grid item md={2} sm={3} xs={6}>
                        <Button
                            color="secondary"
                            disabled={isLoading}
                            fullWidth
                            size="large"
                            variant="outlined"
                            onClick={close}
                        >
                            {t("common:cancel")}
                        </Button>
                    </Grid>
                    {isSimActivated && (
                        <Grid item md={2} sm={3} xs={6}>
                            <Button
                                color="secondary"
                                disabled={isLoading}
                                fullWidth
                                size="large"
                                variant="contained"
                                onClick={confirm}
                            >
                                {t("common:confirm")}
                            </Button>
                        </Grid>
                    )}
                </Grid>
            </DialogActions>
        </Dialog>
    );
};
